<ta-page-container [sidebarProjectedIn]="this.sidebarRef != null">
  <ng-content select="ta-sidebar" ngProjectAs="ta-sidebar"></ng-content>
  <ta-page-body>
    <ta-flexbox
      padding="4rem 8rem"
      margin="0 0 4rem 0"
      class="border--bottom"
      alignItems="center"
      [justifyContent]="headerJustification"
    >
      <span class="thin-heading--1">
        <span> {{ headerText }}</span>
      </span>

      <ng-container *ngIf="headerButtonText">
        <ta-button
          priority="primary"
          (interact)="headerButtonClick.emit()"
          [disabled]="headerButtonDisabled"
          ><span
            >{{ headerButtonText }}
            <ta-spinner-icon
              *ngIf="headerButtonDisabled && headerButtonShowSpinner"
              class="pl--2"
            ></ta-spinner-icon
          ></span>
        </ta-button>
      </ng-container>
    </ta-flexbox>
    <ta-box padding="0 6rem"> <ng-content></ng-content> </ta-box>
  </ta-page-body>
</ta-page-container>
